var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.listCreateConfig)?_c('v-btn',{staticClass:"mx-2",attrs:{"color":_vm.color,"buttonClass":_vm.buttonClass,"small":""},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }